import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import LoadingFade from "../../LoadingFade";
import {useState, useEffect, createRef} from "react";
import {useNavigate, useParams} from "react-router-dom";
import httpService from "../../../services/httpService";
import Button from "react-bootstrap/Button";
import {Modal} from "react-bootstrap";
import EpisodeEditCardList from "../EpisodeEditCardList";

const StepEpisodesInsights = ({onStageChange, onClubChange, podcastClub}) => {
    const navigate = useNavigate();
    const { step, id } = useParams();
    const [loading, setLoading] = useState(false);
    const [pageLoading, setPageLoading] = useState(true);
    const [isWizardCompleted, setIsWizardCompleted] = useState(false);
    const [podcastClubErrors, setPodcastClubErrors] = useState({});
    const [errorMessage, setErrorMessage] = useState('');
    const [clubEpisodes, setClubEpisodes] = useState([]);
    const [showVideoModal, setShowVideoModal] = useState(false);


    const [selectedEpisode, setSelectedEpisode] = useState(
        null);

    const loadStepData = async () => {
        setLoading(true);
        try {
            let endpoint_with_params = "/dash/wizard/get-step/4"+ (id ? "/"+id : "") + (!id && podcastClub ? "/"+podcastClub.guid : '')
            const res = await httpService.get(endpoint_with_params);
            setClubEpisodes(res.data.club_episodes)
            setIsWizardCompleted(res.data.is_wizard_completed)
        } catch (err) {
            setErrorMessage(err.response?.data?.message || "Error loading data");
        } finally {
            console.log(podcastClub)
            setLoading(false);
            setPageLoading(false)
        }
    };

    const goToClubDashboard = () => {
        setPageLoading(true)
        navigate(`/podcaster/podcast-club/${podcastClub.guid}`)
    };

    const getPodcastClubEpisodes = async () => {
        try {
            const res = await httpService.get("dash/club/"+id+'/episodes');
            console.log("parsed:", res.data);
            setClubEpisodes(res.data.episodes)
        } catch (err) {
            setPodcastClubErrors({...err.response.data.errors})
        } finally {
            setLoading(false);
            setPageLoading(false)
        }
    };

    useEffect(() => {
        getPodcastClubEpisodes();
    }, []);

    return(
        <LoadingFade loading={pageLoading} stateKey={pageLoading?'loading':'not-loading'}>
            <Row>
                <Col sm={12}>
                    <h3>Add Insights</h3>
                    <p>For each episode, define the insights listeners should leave with. &nbsp;<a onClick={() => setShowVideoModal(true)} className={"text-secondary collapse-info"} style={{cursor: 'pointer'}}>watch video</a></p>
                </Col>
                {clubEpisodes.map((it) => (
                    <Col sm={12} key={it.id} className="">
                        <EpisodeEditCardList
                            podcastClubGuid={id}
                            episode={it}
                            clubEpisodes={clubEpisodes}
                            onEpisodeSelected={getPodcastClubEpisodes}
                        />
                    </Col>
                ))}
            </Row>
            <Row>
                <Col sm={4} className={'mb-3'}>
                    <label className={'mb-2'}>Go to episodes selection</label>
                    <button
                        className={"btn btn-light btn-block w-100"}
                        onClick={() => onStageChange(3, id)}
                    >
                        Back
                    </button>
                </Col>
                <Col sm={4} className={'mb-3'}>
                    {isWizardCompleted ? (
                        <Button
                            disabled={!(podcastClub.title && podcastClub.description)}
                            variant={'primary'}
                            className={'primary w-100'}
                            onClick={goToClubDashboard}>
                            Back to Club Dashboard
                        </Button>
                    ):''}
                </Col>
                <Col sm={4} className={"mb-3"}>
                    <label className={'mb-2'}>Go to discussions step</label>
                    <Button
                        onClick={()=>onStageChange(5, id)}
                        className="w-100"
                        variant={isWizardCompleted ? 'light' : 'primary'}
                        disabled={!clubEpisodes.every(episode => episode.key_takeaways_count > 0)}
                    >
                        Continue
                    </Button>
                </Col>
            </Row>

            <Modal show={showVideoModal} onHide={() => setShowVideoModal(false)} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Review and add Insights</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div style={{position: 'relative', paddingBottom: '56.25%', height: 0}}>
                        <iframe
                            src="https://www.loom.com/embed/028c5a0146db4a61bc31f7a7789920c3"
                            frameBorder="0"
                            webkitallowfullscreen="true"
                            mozallowfullscreen="true"
                            allowFullScreen
                            style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%'}}
                        />
                    </div>
                </Modal.Body>
            </Modal>
        </LoadingFade>
    )
}

export default StepEpisodesInsights;
